import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Input from 'components/inputs/Input/Input';
import Button2 from 'components/buttons/Button2/Button2';
import { ReactComponent as ArrowTopRight } from 'assets/icons/arrow-top-right.svg';
import withTitle from 'hocs/WithTitle';
import styles from './style.cssmodule.css';
import { useSignIn } from './useSignIn';

const SignIn = ({
  handleFormTypeChange,
}) => {
  const { formatMessage: t } = useIntl();

  const {
    fields,
    changeField,
    errors,
    isSubmitting,
    handleSubmit,
  } = useSignIn();

  // Autofocus on email field when component loads
  useEffect(() => {
    // Timeout to ensure DOM is properly rendered
    const timer = setTimeout(() => {
      const emailInput = document.querySelector('input[name="email"]');
      if (emailInput) {
        emailInput.focus();
      }
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  // Form submission handling (Enter key and prevent page reload)
  const handleFormSubmit = (event) => {
    event.preventDefault();
    handleSubmit();
  };

  // Accessible handling of the "Forgot password" link
  const handleForgotPasswordClick = (event) => {
    event.preventDefault();
    handleFormTypeChange('forgotPassword');
  };

  const handleForgotPasswordKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleFormTypeChange('forgotPassword');
    }
  };

  return (
    <form onSubmit={handleFormSubmit} noValidate>
      <div className={styles.inputGrid}>
        <Input
          label={t({ id: 'field.emailExplicit' })}
          type="email"
          name="email"
          autoComplete="username email"
          disabled={isSubmitting}
          value={fields.email}
          error={errors.email}
          aria-invalid={errors.email ? 'true' : 'false'}
          aria-describedby={errors.email ? 'email-error' : undefined} // Error reference for screen readers
          required
          onChange={({ target: { value: newEmail } }) => changeField({ name: 'email', value: newEmail })}
        />
        <div>
          <Input
            label={t({ id: 'field.password' })}
            type="password"
            name="password"
            autoComplete="current-password"
            disabled={isSubmitting}
            value={fields.password}
            error={errors.password}
            aria-invalid={errors.password ? 'true' : 'false'}
            aria-describedby={errors.password ? 'password-error' : undefined}
            required
            onChange={({ target: { value: newPassword } }) => changeField({ name: 'password', value: newPassword })}
          />
          <div className={styles.forgottenPassword}>
            <span>
              {t({ id: 'info.forgotPasswordLong' })}
            </span>
            {' '}
            <button
              type="button"
              className={styles.resetLink}
              onClick={handleForgotPasswordClick}
              onKeyDown={handleForgotPasswordKeyDown}
              aria-label={t({ id: 'info.resetPassword' })}
              tabIndex={0}
            >
              {t({ id: 'info.resetPassword' })}
            </button>
          </div>
        </div>
      </div>

      <Button2
        htmlType="submit"
        type="primary"
        loading={isSubmitting}
        disabled={isSubmitting}
        className={styles.signInButton}
        size="medium"
        aria-label={t({ id: 'button.signIn' })}
      >
        {t({ id: 'button.signIn' })}
        <ArrowTopRight aria-hidden="true" />
      </Button2>
    </form>
  );
};

SignIn.propTypes = {
  handleFormTypeChange: PropTypes.func,
};

SignIn.defaultProps = {
  handleFormTypeChange: () => {},
};

module.exports = withTitle('pageTitle.login')(SignIn);



// WEBPACK FOOTER //
// ./routes/login/components/cpm_manager/components/SignIn/SignIn.jsx